import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { getIncomeDetail, getIncomeOverView, getOrderDetailIncome, getOrderIncomeStatemnt, getOrderStatementDetail } from "../../helpers/backend_helper";

export const getIcomeOverViewThunk = createAsyncThunk(
  "IcomeOverView/get",
    async ({ page, count, starDate, endDate, orderId, status, keywordType,  keyword,  }: { page: number; count: number, starDate:number, endDate:number, orderId:string, status:any, keywordType:string, keyword: string,  }) => {
  try {
    const response = await getIncomeOverView(page, count, starDate, endDate,orderId, status, keywordType, keyword, );
    return response.data;
  } catch (error) {
    return error;
  }
})

// export const getOrderStatementDetailThunk = createAsyncThunk(
//   "ManegeOrderIcomeOverViewDetail/get",
//     async ({ orderStatementId }: { orderStatementId: string }) => {
//   try {
//     const response = await getIncomeOverViewDetail(orderStatementId);
//     return response.data;
//   } catch (error) {
//     return error;
//   }
// })


export const getStatementOrderDetailThunk = createAsyncThunk(
  "statementDetail/get",
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await getOrderStatementDetail(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getOrderDetailIncomeThunk = createAsyncThunk(
  "orderDetailIncome/get",
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await getOrderDetailIncome(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getIncomeDetailThunk = createAsyncThunk("icomeDetail/get",
    async ({ page, count,starDate,endDate,keyword, status,keywordType }: { page: number; count: number, starDate:number, endDate:number, keyword: string, status:any, keywordType:string }) => {
  try {
    const response = await getIncomeDetail(page, count,starDate,endDate,keyword, status,keywordType);
    return response.data;
  } catch (error) {
    return error;
  }
})

export const getOrderIncomeStatementThunk = createAsyncThunk(
  "OrderIncomeStatement/get",
    async ({ page, count , keyword,  status }: { page: number,count: number,keyword: string,status: string }) => {
  try {
    const response = await getOrderIncomeStatemnt(page, count , keyword,  status);
    return response.data;
  } catch (error) {
    return error;
  }
})